import React from 'react'
import PropTypes from 'prop-types'
import { Button, Link, Panel, Hr, Margin, Table, Text } from 'shared/components'
import { admin } from 'routes/route.map'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as styles from './styles'

const TriggersOverviewComponent = ({ columns, loadTriggers }) => (
  <Panel>
    <Text as="h1" size={18} bold>
      Triggers
    </Text>
    <Margin tb={3}>
      <Hr width="full" />
    </Margin>
    <Margin tb={3}>
      <div css={styles.controlsWrapper}>
        <Link to={admin.triggers.add()}>
          <Button plain>
            <FontAwesomeIcon size="1x" icon="plus-circle" />
            <Text size={11}>Add trigger</Text>
          </Button>
        </Link>
      </div>
    </Margin>
    <Table id="triggers-table" columns={columns} loadData={loadTriggers} />
  </Panel>
)

TriggersOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadTriggers: PropTypes.func,
}

export default TriggersOverviewComponent
